import { deserialize } from 'cerialize'
import { NOTIFICATION_TYPE } from 'Modules'
import { Callback } from 'Src/types/utilTypes'
import { Id } from 'Src/types/aliases'

export class NotificationListModel {
	@deserialize public id: Id
	@deserialize public message: string | null
	@deserialize public subject: string
	@deserialize public slug: string
	@deserialize public group: string
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public read: boolean
	@deserialize public title?: string
	@deserialize public type?: NOTIFICATION_TYPE
	@deserialize public btnTitle?: string
	@deserialize public action?: Callback
}
